<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن پیام تدریجی</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.from_number.val" :description="form.from_number.inv" dir="ltr" label="از شماره" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.max_receiver_count.val" :description="form.max_receiver_count.inv" dir="ltr" label="حداکثر تعداد دریافت" />
                                </CCol>                                
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CTextarea
                                    v-model="form.sms_text.val" :description="form.sms_text.inv"
                                    label="متن پیام" rows="3" @keyup.enter="access=false"/>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                name: {val: '', inv: '', v: { req: true, max: 1024 }},
                from_number: {val: '', inv: '', v: { req: true, max: 1024 }},
                sms_text: {val: '', inv: '', v: { req: true, max: 2048 }},
                max_receiver_count: {val: '', inv: '', v: { req: true, max: 512 }},
                is_active: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            users: [],
            disable: false,
            access: true,
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        submit(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        data.set(key, this.form[key].val);
                    }
                    this.axios.post('out_box_gradual_sms_groups/', data)
                        .then(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'افزودن با موفقیت انجام شد.'
                            });
                            for (const key in this.form){
                                this.form[key].val = '';
                            }
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        },
        get_users(){
            this.axios.get('users/?type=add_out_box_gradual_sms_groups')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_out_box_gradual_sms_group == false
            && this.$store.state.can_add_out_box_gradual_sms_group_for_same_group_users == false
            && this.$store.state.can_add_out_box_gradual_sms_group_for_all_users == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
